import { render, staticRenderFns } from "./booklist.html?vue&type=template&id=9031ef04&scoped=true&"
import script from "./booklist.js?vue&type=script&lang=js&"
export * from "./booklist.js?vue&type=script&lang=js&"
import style0 from "./booklist.sass?vue&type=style&index=0&id=9031ef04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9031ef04",
  null
  
)

component.options.__file = "booklist.vue"
export default component.exports